module.exports = __webpack_public_path__ + "static/media/giftIcon.593d8672.svg";